import styled from "styled-components";
import { Button, colors, typography } from "@streeteasy/design-system";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";

const { BRAND_DARK, GRAY_LIGHTEST, TEXT_SECONDARY } = colors;
const { Caps } = typography;

export const AddButton = styled(Button)`
  background: none;
  border: none;
  color: ${BRAND_DARK};
  height: 100%;
  min-width: auto;
  padding: 0;
  text-transform: uppercase;
  &:hover,
  &:active {
    background-color: transparent;
  }
`;

export const AddIcon = styled(FontAwesomeIcon).attrs({
  iconClass: "plus"
})`
  color: ${BRAND_DARK};
  padding: 0 4px 0 0;
  vertical-align: bottom;
`;

export const Container = styled.div`
  background-color: ${GRAY_LIGHTEST};
  line-height: 15px;
  padding: 16px;
`;

export const Header = styled(Caps)`
  color: ${TEXT_SECONDARY};
  display: inline-block;
`;
